import { useQuery } from '@tanstack/react-query';

import type { InsightsSummary } from '../@types/contracts';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

interface UseGetInsightsSummary {
  organizationId: string;
  startDate: string;
  endDate: string;
  practiceId?: string;
}

export const useGetInsightsSummary = ({
  organizationId,
  startDate,
  endDate,
  practiceId,
}: UseGetInsightsSummary) => {
  const summaryApiPath = `/${endpoints.insights}/${organizationId}/${endpoints.summary}`;

  return useQuery(
    [summaryApiPath, organizationId, startDate, endDate, practiceId],
    () =>
      makeAPIRequestReactQuery<InsightsSummary>(summaryApiPath, {
        startDate: startDate,
        endDate: endDate,
        practiceId: practiceId,
      }),
    {
      enabled: !!organizationId,
    },
  );
};
